import { render, staticRenderFns } from "./systemBasic.vue?vue&type=template&id=c8295bb6&scoped=true"
import script from "./systemBasic.vue?vue&type=script&lang=js"
export * from "./systemBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8295bb6",
  null
  
)

export default component.exports